import React from "react";
import { Navigate } from "react-router-dom";
import { useCookies } from "react-cookie";

const PrivateRoute = ({ children }) => {
  const [cookies] = useCookies(["token", "admin"]);

  return cookies.token && cookies.admin ? (
    children
  ) : (
    <Navigate to="/login" replace />
  );
};

export default PrivateRoute;
